import { IFormButton, IInput } from 'app/services/api5-service/api.interface';

import { isTextControl, TypedControl, TypedControlBase } from '../../controls';
import { ButtonControl } from '../../controls/button';

export interface PromocodeControlWithValue extends TypedControlBase {
  readonly control: IInput;
  readonly button: IFormButton;
  readonly type: 'promocode';
  value: string;
}

/**
 * Merge input and button controls into promocode control
 *
 * @param controls
 */
export function getPromocodeControls(controls: TypedControl[]): TypedControl[] {
  const copy = [...controls];
  return copy.reduce<TypedControl[]>((reducedControls, control) => {
    if (
      control.type !== 'input' ||
      !isTextControl(control.control) ||
      !control.control.$button
    ) {
      reducedControls.push(control);
      return reducedControls;
    }

    const bindedButtonName = control.control.$button;
    const bindedButtonIndex = copy.findIndex(
      c => c.type === 'button' && c.control.$name === bindedButtonName,
    );
    if (bindedButtonIndex < 0) {
      reducedControls.push(control);
      return reducedControls;
    }

    const button = copy.splice(bindedButtonIndex, 1)[0] as ButtonControl;
    reducedControls.push({
      value: control.value,
      button: button.control,
      control: control.control,
      type: 'promocode',
    } as PromocodeControlWithValue);
    return reducedControls;
  }, []);
}
